import ListSelect from 'common/components/selectors/ListSelect';

const AreaSelector = ({ isMulti, filter, value, label, onChange, className, placeholder }) => {
  return (
    <ListSelect
      list="port-areas"
      label={label}
      className={className}
      placeholder={placeholder || 'Select value'}
      getOptionValue={option => option.id}
      getOptionLabel={option => option.name}
      onChange={selected => {
        onChange({
          data: selected ? selected : [],
          value: selected ? (isMulti ? selected : selected) : ''
        });
      }}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      isMulti
      isClearable
    />
  );
};

export default AreaSelector;
